import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=00568ff9&scoped=true&xmlns%3Ath=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=00568ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00568ff9",
  null
  
)

export default component.exports